import ConstructionService from "../services/construction.service";

const state = {
  search: {
    q: "",
    company: [],
    status: ['not_started', 'in_progress', 'not_payment'],
    owner: [],
    year: []
  },
  projects: [],
  available: [],
  availableLoaded: null
};

const getters = {
  search: state => {
    return state.search;
  },
  projects: state => {
    return state.projects;
  },
  availableProjects: state => {
    return state.available;
  }
};

const actions = {
  async doSearch({
    commit
  }, query) {
    let constructions = await ConstructionService.search(query);
    commit("projects", constructions);
    return constructions;
  },
  async create({
    commit
  }, {
    data,
    subcontractors
  }) {
    data.subcontractors = subcontractors.filter((item) => {
      return item.user_id > 0;
    });
    let response = await ConstructionService.create(data);
    commit("projects", []); //clean constructions
    return response;
  },
  async loadProjects({
    commit,
    state
  }) {
    if (!state.availableLoaded || (new Date() - state.availableLoaded) / 1000 > 45) {
      let constructions = await ConstructionService.available();
      commit("available", constructions);
      return constructions;
    }
    return state.available;
  }
};

const mutations = {
  search(state, {
    type,
    value
  }) {
    state.search[type] = value;
  },
  projects(state, payload) {
    state.projects = payload;
  },
  update(state, payload) {
    let index = state.projects.findIndex((item) => item.id === payload.id);
    if (index > -1) {
      state.projects[index] = payload;
    }
  },
  updateField(state, {
    id,
    key,
    value
  }) {
    let index = state.projects.findIndex((item) => item.id === id);
    if (index > -1 && state.projects[index][key]) {
      state.projects[index][key] = value;
    }
  },
  remove(state, construction_id) {
    let index = state.projects.findIndex((item) => item.id === construction_id);
    if (index > -1) {
      state.projects.splice(index, 1);
    }
  },
  available(state, payload) {
    state.availableLoaded = new Date();
    state.available = payload;
  },
  reset(state) {
    state.projects = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};